// extracted by mini-css-extract-plugin
export default {"button":"BuyWithCardButton_button__+VpNJ","modal":"BuyWithCardButton_modal__-AyRx","moonPayFrame":"BuyWithCardButton_moonPayFrame__8P8wS"};